import * as React from 'react';
import { Duration } from '../Duration';
import { useDurations } from '../../hooks/useDurations';
import * as styles from './DurationGrid.css';

export const DurationGrid = () => {
  const { onChange, durations } = useDurations();

  return (
    <div className={styles.root}>
      {durations.map(({ durationInDays, discountPercent, selected, disabled, isPromoDiscount }) => (
        <Duration
          key={durationInDays}
          duration={durationInDays}
          discount={discountPercent}
          disabled={disabled}
          checked={selected}
          isPromoDiscount={isPromoDiscount}
          onClick={onChange}
        />
      ))}
    </div>
  );
};
